import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Config from "../Config";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import Loading from "../Loading";
import { useAuthHandling } from '../useAuthhandling';
import Select from 'react-select';

import Toastmodal from "../Toastmodal";
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");

function Enquiryadd() {
  const toggleRef = useRef(null);
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [auto, setAuto] = useState([]);
  const [searchval, setSearchval] = useState(false);
  const [catid,setCatid]=useState("");
  const [loader,setLoader]=useState(true);
  const [testal, setTestval] = useState("");
  const [indexval,setIndexval]=useState('');
  const [user,setUser]=useState([]);
  const [useroption,setUseroption]=useState([]);
  const [selecteduser,setSelecteduser]=useState([]);

  const [levelName,setLevelName]=useState("");
  const [level1Name,setLevel1Name]=useState("");
  const [level1Id,setLevel1Id]=useState("");
const [searchon,setSearchon]=useState(false);

  const [prof, setProf] = useState([]);
  const [profoption, setProfoption] = useState([]);
  const [selectedprof, setSelectedprof] = useState([]);

  if (!tokens) {
    navigate("/");
  }
  const [location, setLocation] = useState({
    name: "Kochi, Kerala, India",
    lat: 9.9312,
    long: 76.2673,
  });

  const [loc, setLoc] = useState("Kochi, Kerala, India");
  const [checke, setChecked] = useState("Job-enquiry");
  const [addressstring, setaddressstring] = useState(
    "W7M9+9C Kochi, Kerala, India"
  );
  const [enquiry, setEnquiry] = useState([]);
  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setEnquiry({ ...enquiry, [name]: value });
  };

  const validate = (values) => {
    const errors = {};

    if (!selecteduser?.value) {
      errors.customer = "Customer is required!";
    }

   
    if(checke==="Job-enquiry"){
      if (!catid) {
        errors.professionalCategory = "Category is required!";
      }
    }
    else{
      if (!selectedprof?.value) {
        errors.professionalname = "professionalname is required!";
      }
    }
    
    if (!values.requirement) {
      errors.requirement = "Requirement is required!";
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    
    const ress = validate(enquiry);

    setError(ress);

    if(checke==="Job-enquiry"){
      if (
        !ress.customer &&
        !ress.requirement &&
        catid
      ) {
        if(level1Name){
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/enquiry/create-enquiry`,
          {
            method: "POST",
  
            body: JSON.stringify({
              levelOneId: level1Id,
              levelOneName:level1Name,
              levelTwoId:catid,
              levelTwoName:testal,
              location: location.name,
              latitude: location.lat,
              longitude: location.long,
              requirement: enquiry.requirement,
              customer: selecteduser?.value,
              enquiryType:checke,
              terms: true,
            }),
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        );
  
        if (res.status === 200) {
          const data = await res.json();

          setToastmodal(true);
          setToastmessage("Sucessfully Submitted Enquiry ");
          setToasttype("success");
          setToastlarge(false);
          setTimeout(() => navigate("/dashboard"), 3000);
       
        } 
        else if(res.status === 401){
          handleUnauthorized();
          PostData();
        }
        else {
          const data = await res.json();

          setToastmodal(true);
          setToastmessage(data.message);
          setToasttype("error");
          setToastlarge(true);
        }
      }
      else{
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/enquiry/create-enquiry`,
          {
            method: "POST",
  
            body: JSON.stringify({
              levelOneId: catid,
              levelOneName:testal,  
              levelTwoId:"",
              levelTwoName:"",
              location: location.name,
              latitude: location.lat,
              longitude: location.long,
              requirement: enquiry.requirement,
              customer: selecteduser?.value,
              enquiryType:checke,
              terms: true,
            }),
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        );
  
        if (res.status === 200 ) {
          setToastmodal(true);
          setToastmessage("Sucessfully Submitted Enquiry ");
          setToasttype("success");
          setToastlarge(false);
          setTimeout(() => navigate("/dashboard"), 3000);
         
        } 
        else if(res.status === 401){
          handleUnauthorized();
          PostData();
        }
        else {
          const data = await res.json();

          setToastmodal(true);
          setToastmessage(data.message);
          setToasttype("error");
          setToastlarge(true);
        }
      }
      }
      else{
        console.log("error");
      }
    }
    else{
    if (
      !ress.customer &&
      !ress.requirement &&
      !ress.professionalname
    ) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/enquiry/create-enquiry`,
        {
          method: "POST",

          body: JSON.stringify({
            professional: selectedprof?.value,
            location: location.name,
            latitude: location.lat,
            longitude: location.long,
            requirement: enquiry.requirement,
            customer: selecteduser?.value,
            enquiryType:checke,
            terms: true,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200 ) {
        setToastmodal(true);
        setToastmessage("Sucessfully Submitted Enquiry ");
        setToasttype("success");
        setToastlarge(false);
        setTimeout(() => navigate("/dashboard"), 3000);
       
      } 
      else if(res.status === 401){
        handleUnauthorized();
        PostData();
      }
      else {
        const data = await res.json();

        setToastmodal(true);
        setToastmessage(data.message);
        setToasttype("error");
        setToastlarge(true);
      }
    }
    else{
      console.log("error");
    }
  }
  };

  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
    setLoc(value);
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
    setLoc(value);
  };

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/professional/get-verified-professionals`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {  
      const data = await res.json();
    
      setProf(data.data);

    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  const getuser = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/enquiry/get-users`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setUser(data.data);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getuser();
    }
    else {
      alert("error");

    }
  };

  const getautocomplete = async (id) => {
    const res = await fetch(`${Config.apiurl}/api/v1/common/category-autocomplete`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keyString: id,
      }),
    });
    const data1 = await res.json();
    const data = data1.data;
    if (res.status === 404 || !data) {
      setToastmodal(true);
      setToastmessage("Something went wrong!");
      setToasttype("error");
      setToastlarge(false);
    } else {
      setLoader(false)

      setAuto(data);
      if (data.length > 0) {
        setSearchval(true);
      }
    }
  };
  useEffect(() => {
    getinfo();
    getuser();
    document.addEventListener("mousedown", handleClickOutside);

  }, []);

  // React.useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);
  // });

  const handleClickOutside = (event) => {
    if (toggleRef.current && !toggleRef.current.contains(event.target)) {
      setSearchval(false);
    }
  };

  useEffect(()=>{
    const options = user.map(item => ({ value: item?._id, label: item?.name }));
    setUseroption(options);
  },[user])

  useEffect(()=>{
    const options = prof.map(item => ({ value: item?.userId?._id, label: item?.userId?.name }));
    setProfoption(options);
  },[prof])

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Enquiry Add</h4>
                      <form className="forms-sample">
                        <div className="row">
                          <div className="form-group col-sm-12 ">
                            <label htmlFor="exampleInputUsername1">
                              Customer Name
                            </label>

                            <Select 
                            
                            options={useroption}
                            isSearchable={true}
                            value={selecteduser}
                            className="my-select"
                            onChange={setSelecteduser}
                            // placeholder="Select the number of bedrooms"
                            />
                            {/* <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                value={enquiry.customer}
                              onChange={handleInputs}
                                name="customer"
                              >
                                <option id="exampleInputUsername1">
                                  Choose Customer
                                </option>

                                {user.map((cate, index) => {
                                  return (
                                    <option key={index} value={cate._id}>
                                      {cate.name}
                                    </option>
                                  );
                                })}
                              </select> */}
                          
                            <label style={{ color: "red" }}>
                              {formerror.customer}
                            </label>
                          </div>
                        </div>
                        <div className="form-group col-sm-12">
                          <label>Enquiry type</label>
                          <div className="switch-field">
                            <input
                              type="radio"
                              id="radio-one"
                              name="switch-one"
                              value="Direct-enquiry"
                              checked={checke === "Direct-enquiry"}
                              onChange={(e) => setChecked(e.target.value)}
                            />
                            <label for="radio-one">Direct Enquiry</label>
                            <input
                              type="radio"
                              id="radio-two"
                              name="switch-one"
                              value="Job-enquiry"
                              checked={checke === "Job-enquiry"}
                              onChange={(e) => setChecked(e.target.value)}
                            />
                            <label for="radio-two">Category Enquiry</label>
                          </div>
                        </div>
                        {checke === "Direct-enquiry" ? (
                          <div className="form-group col-sm-12">
                            <label>Professional Name</label>
                            <Select 
                            
                            options={profoption}
                            isSearchable={true}
                            className="my-select"
                            value={selectedprof}
                            onChange={setSelectedprof}
                            // placeholder="Select the number of bedrooms"
                            />
                            {/* <select
                              className="form-control "
                              style={{
                                color: "black",
                                backgroundColor: "#2b2e4c;",
                              }}
                              id="exampleInputUsername1"
                              name="professionalname"
                              onChange={handleInputs}
                              value={enquiry.professionalname}
                            >
                              <option id="exampleInputUsername1">
                                Choose Profesional
                              </option>

                              {prof.map((cate, index) => {
                                return (
                                  <option key={index} value={cate?.userId?._id}>
                                    {cate?.userId?.name}
                                  </option>
                                );
                              })}
                            </select> */}
                            <label style={{ color: "red" }}>
                              {formerror.professionalname}
                            </label>
                          </div>
                        ) : (
                          <div className="form-group col-sm-12">
                            <label>Category Name</label>
                            <input
                className="form-control"
                placeholder=" Search Category"
                onChange={(e) => {
                  setTestval(e.target.value); getautocomplete(e.target.value);
                }}
                value={testal}
              />
              {searchval ? (
                <div className="searchcategory" ref={toggleRef}>
                   {loader===false?
                    auto.length >0?
                 
                  auto.map((valu, i) => {
                    return (
                      <Link
                        to="#"
                        className={i === indexval ? "activesearchlink searchcategory_link":"searchcategory_link"}
                        key={i}
                        onClick={(e) => {
                          setTestval( valu.levelFourName? valu.levelFourName:valu.levelThreeName?valu.levelThreeName:valu.levelTwoName?valu.levelTwoName:valu.levelOneName); setSearchval(!searchval);setIndexval(i);setLevelName(valu.levelFourName? 4:valu.levelThreeName?3:valu.levelTwoName?2:1);
                          setCatid(valu.levelFourName? valu.levelFourId:valu.levelThreeName?valu.levelThreeId:valu.levelTwoName?valu.levelTwoId:valu.levelOneId);
                          setLevel1Id(valu.levelTwoId?valu.levelOneId:"");
                          setLevel1Name(valu.levelTwoName?valu.levelOneName:"");
                        }}
                      >
                        {valu.levelFourName? valu.levelFourName:valu.levelThreeName?valu.levelThreeName:valu.levelTwoName?valu.levelTwoName:valu.levelOneName}
                        
                      </Link>
                    );
                  }):
                  
                  <div className="">
                     No matching records were found
                  </div>
                  :<Loading/>
                  
                  }
                </div>
              ) : (
                ""
              )}

                          <label style={{ color: "red" }}>
                              {formerror.professionalCategory}
                            </label>
                          </div>
                        )}

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Requirement
                          </label>
                          <textarea
                            className="form-control"
                            id="description"
                            type="text"
                            rows="5"
                            name="requirement"
                            placeholder="requirement"
                            autoComplete="off"
                            required
                            value={enquiry.requirement}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.requirement}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Location
                          </label>
                          <PlacesAutocomplete
                            value={location.name}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            name="location"
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div className="position-relative">
                                <input
                                  className="form-control"
                                  {...getInputProps({
                                    placeholder: " Enter your location",
                                  })}
                                  required
                                />

                                <div className="autocomplete-dropdown-container">
                                  {loading ? <div>...Loading</div> : null}

                                  {suggestions.map((suggestion, key) => {
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        };

                                    return (
                                      <div
                                        className="form-conterol"
                                        {...getSuggestionItemProps(suggestion, {
                                          style,
                                        })}
                                        key={key}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>

                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Enquiryadd;
